import { Stack, TextField } from "@mui/material";
import {
  GridPagination,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { ComponentProps, FormEvent, useState } from "react";

import { useTranslation } from "@/context/I18nProvider";

// The grid's pagination plus a page-number box, so a long list does not need a click per page.
const GridPaginationJump = (props: ComponentProps<typeof GridPagination>) => {
  const { t } = useTranslation();
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const [draft, setDraft] = useState("");

  const jump = (event: FormEvent) => {
    event.preventDefault();
    const page = Number(draft);
    if (page >= 1) apiRef.current.setPage(Math.min(page, pageCount) - 1);
    setDraft("");
  };

  return (
    <Stack direction="row" alignItems="center">
      {/* With two pages the arrows already reach every page. */}
      {pageCount > 2 && (
        <Stack component="form" onSubmit={jump} sx={{ display: { xs: "none", sm: "flex" }, mr: 1 }}>
          <TextField
            size="small"
            value={draft}
            onChange={(event) => setDraft(event.target.value.replace(/\D/g, ""))}
            placeholder={t("common.goToPage")}
            autoComplete="off"
            sx={{ width: 120 }}
            slotProps={{
              htmlInput: {
                inputMode: "numeric",
                "aria-label": t("common.goToPage"),
                max: pageCount,
              },
            }}
          />
        </Stack>
      )}
      <GridPagination {...props} />
    </Stack>
  );
};

export default GridPaginationJump;
